import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePayment } from "../../../Redux/Customers/Payment/Action";
import { getOrderById } from "../../../Redux/Customers/Order/Action";
import OrderTraker from "../orders/OrderTraker";
import AddressCard from "../adreess/AdreessCard";
import { useParams } from "react-router-dom";
import Navbar from "../../../components/Navbar";

const PaymentSuccess = () => {
  const [paymentId, setPaymentId] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const { orderId } = useParams();

  const jwt = localStorage.getItem("jwt");
  const dispatch = useDispatch();
  const { order } = useSelector((store) => store);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setPaymentId(urlParams.get("razorpay_payment_id"));
    setReferenceId(urlParams.get("razorpay_payment_link_reference_id"));
    setPaymentStatus(urlParams.get("razorpay_payment_link_status"));
  }, []);

  useEffect(() => {
    if (paymentId && paymentStatus === "paid") {
      const data = { orderId, paymentId, jwt };
      dispatch(updatePayment(data));
      dispatch(getOrderById(orderId));
    }
  }, [orderId, paymentId]);

  return (
    <>
      <Navbar />
      <div className="px-2 lg:px-36 bg-black min-h-screen h-full pt-40">
        <div className="flex flex-col justify-center items-center">
          <div className="bg-green-500 text-white px-4 py-2 rounded-md shadow-lg mb-6">
            <p className="font-bold">Payment Success</p>
            <p>Congratulations! Your order has been placed.</p>
          </div>
        </div>

        <OrderTraker activeStep={1} />

        <div className="space-y-5 py-5 ">
          {order.order?.orderItems.map((item) => (
            <div
              key={item.product._id}
              className="grid grid-cols-1 lg:grid-cols-2 shadow-xl rounded-md p-5 border "
            >
              <div className="flex items-center">
                <img
                  className="w-[5rem] h-[5rem] object-cover object-top"
                  src={item?.product.imageUrl}
                  alt=""
                />
                <div className="ml-5">
                  <p className="text-gray-300">{item.product.title}</p>
                  <p className="opacity-50 text-xs font-semibold space-x-5 text-gray-400">
                    <span>Color: Pink</span>
                    <span>Size: {item.size}</span>
                  </p>
                  <p className="text-gray-300">Seller: {item.product.brand}</p>
                  <p className="text-gray-300">₹{item.price}</p>
                </div>
              </div>
              <div className=" lg:mt-0">
                <AddressCard address={order.order?.shippingAddress} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
